import { Heading, Paragraph } from '@audio-network/componentlibrary'

import { NoResultsPromptSearchProps } from './NoResultsPromptSearch.types'
import { Sparkle } from '@audio-network/componentlibrary/icons'
import { sendAnalytics } from '@audio-network/analytics'
import styles from './NoResultsPromptSearch.module.css'
import useAiSearchStore from '@/stores/aiSearchStore'
import { useTranslation } from 'next-i18next'

const NoResultsPromptSearch = ({
	query,
}: NoResultsPromptSearchProps): JSX.Element => {
	const { t } = useTranslation(['search'])
	const { setSearchByPrompt } = useAiSearchStore()

	const handleTryPrompt = (): void => {
		sendAnalytics({
			noun: 'No Results Link',
			pastTenseVerb: 'Clicked',
			eventParameters: {
				Term: query,
			},
		})
		setSearchByPrompt(query)
	}

	return (
		<>
			<div className={styles.noResultsAiContainer}>
				<Sparkle className={styles.noResultsAiIcon} />
				<Heading level={2} size="XS">
					{t('no-results-enhance-your-search')}
				</Heading>
				<Paragraph>
					{t('no-results-try-prompt-text')}
					<i>&quot;{query}&quot;</i> {t('no-results-try-prompt-as-a')}{' '}
					<button className={styles.noResultsAiLink} onClick={handleTryPrompt}>
						{t('no-results-try-prompt-link')}
					</button>
				</Paragraph>
				<Paragraph className={styles.noResultsAiDescription}>
					{t('no-results-try-prompt-description')}
				</Paragraph>
			</div>
		</>
	)
}

export default NoResultsPromptSearch
